import {
  EarningsInsightType,
  EventFeedType,
  ExploreInsightCondition,
  ExploreInsightDirection,
  IconDisplayRule,
  InsightFilter,
  SummaryInsightType,
} from '@toggle/toggle';
import { t } from 'i18next';

export type InsightCardType = InsightFilter & {
  conditions: ExploreInsightCondition[];
  direction: ExploreInsightDirection;
  date: string;
};

export type InsightsPeriod = {
  duration: number;
  unit: string;
};

export const DEFAULT_WHATS_NEW_PERIOD: InsightsPeriod = {
  duration: 1,
  unit: 'day',
};

export const getAnalysisTypes = (): {
  id: NonNullable<IconDisplayRule>;
  title: string;
}[] => [
  { id: 'fundamentals', title: t('whatsNew:fundamentals') },
  { id: 'technicals', title: t('whatsNew:technicals') },
  { id: 'macroeconomics', title: t('whatsNew:macro') },
];

export const getEarningsTypes = (): {
  id: NonNullable<EarningsInsightType>;
  title: string;
}[] => [
  { id: 'preview', title: t('whatsNew:previews') },
  { id: 'recap', title: t('whatsNew:recaps') },
];

export const getSummariesTypes = (): {
  id: NonNullable<SummaryInsightType>;
  title: string;
}[] => [{ id: 'market', title: t('whatsNew:market') }];

export type WhatsNewTabType =
  | 'all'
  | 'company_catalyst'
  | 'market_catalyst'
  | 'scenarios'
  | 'earnings';

export const tabTypeToEventFeedType: Record<
  WhatsNewTabType,
  EventFeedType | undefined
> = {
  all: undefined,
  company_catalyst: 'attribution-insight',
  market_catalyst: 'attribution-insight',
  scenarios: 'scenario-insight',
  earnings: 'earnings-insight',
};

export const isInsightsPeriod = (value: unknown): value is InsightsPeriod =>
  typeof value === 'object' &&
  value !== null &&
  'duration' in value &&
  'unit' in value;
